import { Injectable } from '@angular/core';
import {HttpService} from './http.service';
import {environment} from '@shared-environments/environment';

@Injectable()
export class ProfileService {

  constructor(private networkHelper: HttpService) { }


  private getAccountUrl = '/user/{{id}}';
  private getAccountByDomainUrl = '/user/by-domain/{{id}}';
  private getPlayedGamesUrl = '/user/user-games/{{id}}';

  getAccount(accountId: any): any {
    return this.networkHelper.getWithSSR<any>(environment.apiURL + this.getAccountUrl.replace('{{id}}', accountId));
  }
  getAccountByDomain(domain: any): any {
    return this.networkHelper.getWithSSR<any>(environment.apiURL + this.getAccountByDomainUrl.replace('{{id}}', domain));
  }
  getPlayedGames(accountId: any){
    return this.networkHelper.get<any>(environment.apiURL + this.getPlayedGamesUrl.replace('{{id}}', accountId));
  }
}
